const initialState = {
  maintenance: false,
  maintenanceComment: '',
  profilePhotoLimit: 12,
  profileKeywordLimit: 30,
  favoriteLimit: 300,
  postCommentWordLimit: 1000,
  qaQuestionLimit: 30,
  refusalLimit: 1000,
  nondisplayLimit: 3000,
	socketEndpint: 'https://websocket.partner-s.net:8080',
	datetime: null,
};


export default function reducer(state = initialState, action) {

	if (action.type === "CONFIG_SET"){
    let newState = Object.assign({}, state);
    if (action.payload.config.maintenance === true) {
      newState.maintenance = true;
      newState.maintenanceComment = action.payload.config.maintenanceComment;
    }
    else {
      newState.maintenance = false;
      newState.maintenanceComment = '';
    }
    if (action.payload.config.favoriteLimit) {
      newState.favoriteLimit = action.payload.config.favoriteLimit;
    }
    if (action.payload.config.refusalLimit) {
      newState.refusalLimit = action.payload.config.refusalLimit;
    }
    if (action.payload.config.nondisplayLimit) {
      newState.nondisplayLimit = action.payload.config.nondisplayLimit;
    }
    if (action.payload.config.postCommentWordLimit) {
      newState.postCommentWordLimit = action.payload.config.postCommentWordLimit;
    }
    if (action.payload.config.qaQuestionLimit) {
      newState.qaQuestionLimit = action.payload.config.qaQuestionLimit;
    }
    if (action.payload.config.socketEndpint) {
      newState.socketEndpint = action.payload.config.socketEndpint;
    }
		newState.datetime = (new Date());

		return newState;
	}
	else {
		return state;
	}

}
